<template>
  <div class="g-tile">
    <div class="g-tile-top has-background-black has-text-primary">
      <div class="g-tile-top-sq has-background-primary"></div>
      <p class="m-t-sm p-none m-b-none is-size-5 m-l-none">{{ game.name.toUpperCase() }}</p>
      <p class="m-none p-none is-size-6">{{ $t(tag || game.tags[0]) }}</p>
    </div>
    <div class="g-tile-bottom has-text-primary has-background-black is-size-5">
      <div class="m-md">
        <span :class="game.score > 0.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
        <span :class="game.score > 1.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
        <span :class="game.score > 2.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
        <span :class="game.score > 3.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
        <span :class="game.score > 4.5 ? 'has-text-primary' : 'has-text-grey'">&#9733; </span>
        ({{ game.votes }})
      </div>
    </div>
    <img :src="game.icon" style="width:100%;">
  </div>
</template>
<script>
export default {
  props: {
    game: {
      type: Object
    },
    tag: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style>
.g-tile {
  position: relative;
}
.g-tile-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4.2rem;
}
.g-tile-top-sq {
  margin: 0.8rem 1rem;
  height: 2.5rem;
  width: 2.5rem;
  float: left;
}
.g-tile-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/LangGG/GameTile.vue